"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _RegionalOfficeListing = _interopRequireDefault(require("./RegionalOfficeListing"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    countryWrapper: {
      marginBottom: '32px',
      borderBottom: "1px solid ".concat(theme.palette.grey[400])
    },
    countryName: {
      textTransform: 'uppercase',
      fontWeight: 900,
      marginBottom: '16px',
      fontSize: '20px'
    }
  };
});
var OtherCountryOfficeListing = function OtherCountryOfficeListing(props) {
  var id = props.id,
    name = props.name,
    entities = props.entities;
  var classes = useStyles();
  return __jsx(_core.Grid, {
    container: true,
    className: classes.countryWrapper
  }, __jsx(_core.Grid, {
    item: true,
    xs: 12
  }, name && __jsx("div", {
    id: id,
    className: classes.countryName,
    dangerouslySetInnerHTML: {
      __html: name
    }
  })), entities && entities.map(function (items, index) {
    return __jsx(_core.Grid, {
      item: true,
      xs: 12,
      key: index
    }, __jsx(_RegionalOfficeListing.default, items));
  }));
};
var _default = OtherCountryOfficeListing;
exports.default = _default;